export const selectPendingGuaranteesProductFamily = state => state.data.pendingGuarantees.selectedProduct;
